import { useCallback, useEffect } from 'react';
import {
  useMessagesStore,
  useMessagesStoreHydration,
} from './useMessagesStore';
import { useWidgetConfig } from './useWidgetConfig';
import useWidgetDataAttr from './useWidgetDataAttr';

// messages store initialization hook - similar to useSenderInit
export const useMessagesStoreInit = () => {
  const { companyId } = useWidgetDataAttr();
  const { config: widgetConfig } = useWidgetConfig();
  const {
    actions: { getStorageKey },
  } = useMessagesStore();
  const hydrated = useMessagesStoreHydration();

  const initializeMessagesStore = useCallback(async () => {
    const storageKey = getStorageKey(
      widgetConfig?.channelIdentityId || '',
      companyId || '',
    );

    if (!widgetConfig?.channelIdentityId || !companyId) {
      return;
    }

    if (useMessagesStore.persist.getOptions().name !== storageKey) {
      useMessagesStore.persist.setOptions({
        name: storageKey,
      });
      useMessagesStore.persist.rehydrate();
      return;
    }
  }, [getStorageKey, widgetConfig, companyId]);

  // initialize storage key when widget config is available
  useEffect(() => {
    initializeMessagesStore();
  }, [initializeMessagesStore]);

  return hydrated;
};
